module.exports = __webpack_public_path__ + "img/Volkswagen.8526f7e3.png";